import { useCallback } from 'react';

import { LocalStore } from 'constants/localstore';
import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';
import { SbViewMode } from 'components/app/storyboard/_mediator/sb.slice';
import { Sort } from 'components/app/projects/_mediator/projects.slice';

export interface ProjectLocalstore {
  sbViewMode: SbViewMode;

  // select
  folderId: FolderId | null;
  projectId: ProjectId | null;
  storyId: StoryId | null;
  fileId: FileId | null;
  finalcutId: FinalcutId | null;

  // collapse
  foldersTableState: boolean;
  projectsTableState: boolean;
  filesTableState: boolean;
  storiesTableState: boolean;
  finalCutsTableState: boolean;

  // sort
  foldersTableSort: Sort;
  filesTableSort: Sort;
  storiesTableSort: Sort;
  projectsTableSort: Sort;
  finalCutsTableSort: Sort;

  // filters
  foldersSearchFilter: string | null;
  projectsSearchFilter: string | null;
  filesSearchFilter: string | null;
  storiesSearchFilter: string | null;
  finalCutsSearchFilter: string | null;
}

export const useStoreProject = () => {
  const store = useAppStore();
  const storeProject = useCallback(() => {
    const { appRestored, project } = selectData(store.getState());
    if (!appRestored) return;
    localStorage.setItem(LocalStore.project, JSON.stringify(project));
  }, []);
  return { storeProject };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { appRestored } = state.app;
  const sbViewMode = state.sb.sbViewMode;
  const {
    selectedFile,
    selectedStory,
    selectedProject,
    selectedFinalcut,
    selectedFolder,
    foldersSearchFilter,
    projectsSearchFilter,
    storiesSearchFilter,
    finalCutsSearchFilter,
    filesSearchFilter,
    foldersTableState,
    storiesTableState,
    projectsTableState,
    finalCutsTableState,
    filesTableState,
    foldersTableSort,
    projectsTableSort,
    filesTableSort,
    storiesTableSort,
    finalCutsTableSort,
  } = state.projects;
  const project: ProjectLocalstore = {
    projectId: selectedProject,
    foldersSearchFilter,
    projectsSearchFilter,
    foldersTableState,
    projectsTableState,
    foldersTableSort,
    projectsTableSort,
    filesTableSort,
    storiesTableSort,
    filesSearchFilter,
    filesTableState,
    storiesSearchFilter,
    storiesTableState,
    finalCutsSearchFilter,
    finalCutsTableSort,
    finalCutsTableState,
    fileId: selectedFile ?? null,
    storyId: selectedStory,
    finalcutId: selectedFinalcut,
    folderId: selectedFolder,
    sbViewMode,
  };
  return { appRestored, project };
};
